export const PosTerminals = {
  en: {
    'POS Terminals': 'POS terminals',
    'Create POS Terminal': 'Create POS terminal',
    Location: 'Location',
    'Cash Register': 'Cash register',
    'MAC Address': 'MAC address',
    Model: 'Model',
    Bank: 'Bank',
    Protocol: 'Protocol',
    Port: 'Port',
    'Merchant ID': 'Merchant ID',
    Notes: 'Notes',
    'PayBridge 2.x': 'PayBridge 2.x',
    Online: 'Online',
    Offline: 'Offline',
    'Invalid MAC address format':
      'Invalid MAC address format (AA:BB:CC:DD:EE:FF)',
    'Port must be between {{min}} and {{max}}':
      'Port must be a number between {{min}} and {{max}}',
    'Merchant ID is required for SSI JSON terminals':
      'Merchant ID is required for SSI JSON terminals',
  },
  uk: {
    'POS Terminals': 'POS-термінали',
    'Create POS Terminal': 'Створити POS-термінал',
    Location: 'Локація',
    'Cash Register': 'Каса',
    'MAC Address': 'MAC адреса',
    Model: 'Модель',
    Bank: 'Банк',
    Protocol: 'Протокол',
    Port: 'Порт',
    'Merchant ID': 'Ідентифікатор продавця',
    Notes: 'Нотатки',
    'PayBridge 2.x': 'PayBridge 2.x',
    Online: 'Онлайн',
    Offline: 'Офлайн',
    'Invalid MAC address format':
      'Невірний формат MAC адреси (AA:BB:CC:DD:EE:FF)',
    'Port must be between {{min}} and {{max}}':
      'Порт має бути числом від {{min}} до {{max}}',
    'Merchant ID is required for SSI JSON terminals':
      "Ідентифікатор продавця обов'язковий для терміналів SSI JSON",
  },
};

export const PosTerminalForm = {
  en: {
    ...PosTerminals.en,
    'POS Terminal': 'POS terminal',
    'New POS Terminal': 'New POS terminal',
    'Edit POS Terminal': 'Edit POS terminal',
    'Update POS Terminal': 'Update POS terminal',
    'Cash register hint':
      'Only "Terminal" cash registers of this location that have no other POS terminal are listed. Card payments sent to this POS terminal are recorded to this cash register.',
  },
  uk: {
    ...PosTerminals.uk,
    'POS Terminal': 'POS-термінал',
    'New POS Terminal': 'Новий POS-термінал',
    'Edit POS Terminal': 'Редагування POS-терміналу',
    'Update POS Terminal': 'Оновити POS-термінал',
    'Cash register hint':
      "Показані лише каси типу «Термінал» цієї локації, до яких ще не прив'язано інший POS-термінал. Оплати, відправлені на цей POS-термінал, зараховуються в цю касу.",
  },
};
